import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import constants from 'Constants'

import GetAdvertiserQuery from 'GraphQueries/Advertisers/GetQuery';
import UpdateAdvertiserMutation from 'GraphQueries/Advertisers/UpdateMutation';
import NewReportMutation from 'GraphQueries/Reports/NewMutation';
import UpdateReportMutation from 'GraphQueries/Reports/UpdateMutation';
import UpdateReportFileMutation from 'GraphQueries/Reports/UpdateFileMutation';
import DeleteReportMutation from 'GraphQueries/Reports/DeleteMutation';

import PageNavigationTabs from 'Components/Presentation/_Shared/Layout/PageNavigationTabs';
import AdvertiserEdit from 'Components/Presentation/Advertisers/AdvertiserEdit';
import ReportList from 'Components/Presentation/Advertisers/Reports/ReportList';
import ACLList from 'Components/Presentation/Advertisers/ACLs/ACLList';
import BrandList from 'Components/Presentation/Advertisers/Brands/BrandList';

const uuidv4 = require('uuid/v4');

const _ = require('lodash');

class AdvertiserEditContainer extends React.Component {

    static defaultProps = {
        advertiser: { name: '', postClickLookback: 30, postViewLookback: 30, costModifier: 1.25, reports: [], acl: [] },
        loading: false,
        pageTabs: [
            { label: 'Back To List', path: 'list', includeId: false },
            { label: 'Settings', path: 'manage/settings', includeId: true },
            { label: 'Placement Classifications', path: 'manage/placement-classifications', includeId: true },
            { label: 'Reports', path: 'manage/reports', includeId: true },
            { label: 'ACL', path: 'manage/acls', includeId: true },
            { label: 'Brand', path: 'manage/brands', includeId: true }
        ]
    }

    state = {
        activeTabIndex: 1,
        saving: false
    }

    tabClickHandler = (el, key) => {
        const { history, match: { params } } = this.props;
        history.push(el.includeId ?
            `/organisations/advertisers/${params.id}/${el.path}` :
            `/organisations/advertisers/${el.path}`);
        this.setState({ activeTabIndex: key });
    }

    setActiveTab = index => {
        this.setState({ activeTabIndex: index });
    }

    saveAdvertiser = (advertiser, action = '') => {
        const { onAlert, onUpdate } = this.props;
        this.setState({ saving: true }, () => {

            onUpdate(_.omit(advertiser, ["__typename", "reports", "accessControlList"])).then(x => {
                let message = '';
                switch (action) {
                    case 'add_acl':
                        message = `Successfully added acl to advertiser: ${advertiser.id}`;
                        advertiser.reports.forEach(element => {
                            this.props.onUpdateReport({ id: element.id, version: element.version, status: element.status, acl: advertiser.acl });
                        });
                        break;
                    case 'update_acl':
                        message = `Successfully updated acl on advertiser: ${advertiser.id}`;
                        advertiser.reports.forEach(element => {
                            this.props.onUpdateReport({ id: element.id, version: element.version, status: element.status, acl: advertiser.acl });
                        });
                        break;
                    case 'delete_acl':
                        message = `Successfully deleted acl on advertiser: ${advertiser.id}`;
                        advertiser.reports.forEach(element => {
                            this.props.onUpdateReport({ id: element.id, version: element.version, status: element.status, acl: advertiser.acl });
                        });
                        break;
                    case 'add_brand':
                        message = `Successfully added brand to advertiser: ${advertiser.id}`;
                        break;
                    case 'update_brand':
                        message = `Successfully updated brand on advertiser: ${advertiser.id}`;
                        break;
                    case 'delete_brand':
                        message = `Successfully deleted brand on advertiser: ${advertiser.id}`;
                        break;
                    default:
                        message = `Successfully updated advertiser: ${advertiser.id}`;
                        break;
                }
                this.setState({ saving: false });
                onAlert('success', `${message}`);
            }).catch(error => {
                if (error.graphQLErrors) {
                    error.graphQLErrors.map(({ message }, i) => {
                        if (message.match(/not authorized/gi)) {
                            onAlert('error', 'You are not authorised to edit advertisers, please see a System Admin');
                        }
                        else { onAlert('error', message); }
                    });
                }
                this.setState({ saving: false });
            });
        });
    }

    createReport = event => {
        const { target: { files: [file] } } = event;
        const { onAlert, onAddReport, match: { params } } = this.props;
        if (file) {
            this.setState({ saving: true });
            let id = uuidv4().replace(/-/g, '')
            const { name } = file;
            const bucket = constants.s3_bucket;
            const region = constants.s3_region;
            onAddReport({
                id: id, version: 1, name: name, advertiserId: params.id, status: 'uploading', file: {
                    bucket,
                    mimeType: 'application/pbix',
                    key: `${constants.s3_file_prefix}/report-files/${params.id}/${id}/v1/${name.replace(/ /g, '-').toLowerCase()}`,
                    region,
                    localUri: file,
                }
            }).then(x => {
                onAlert('success', `Successfully created report: ${name}`);
                this.setState({ saving: false });
            }).catch(error => {
                if (error.graphQLErrors) {
                    error.graphQLErrors.map(({ message }, i) => {
                        if (message.match(/not authorized/gi)) {
                            onAlert('error', 'You are not authorised to create reports, please see a System Admin');
                        }
                        else { onAlert('error', message); }
                    });
                } else { console.log(error); }
                this.setState({ saving: false });
            });
        }
    }
    updateReportFile = (event, report) => {
        const { target: { files: [file] } } = event;
        const { onAlert, onUpdateReportFile, match: { params } } = this.props;
        if (file) {
            this.setState({ saving: true }, () => {
                const { name } = file;
                const bucket = constants.s3_bucket;
                const region = constants.s3_region;
                const version = report.version + 1;
                onUpdateReportFile({
                    id: report.id,
                    name: report.name,
                    version,
                    status: 'uploading',
                    file: {
                        bucket,
                        mimeType: 'application/pbix',
                        key: `${constants.s3_file_prefix}/report-files/${params.id}/${report.id}/v${version}/${name.replace(/ /g, '-').toLowerCase()}`,
                        region,
                        localUri: file,
                    }
                }).then(x => {
                    onAlert('success', `Successfully uploaded report: ${name}`);
                    this.setState({ saving: false });
                }).catch(error => {
                    if (error.graphQLErrors) {
                        error.graphQLErrors.map(({ message }, i) => {
                            if (message.match(/not authorized/gi)) {
                                onAlert('error', 'You are not authorised to create reports, please see a System Admin');
                            }
                            else { onAlert('error', message); }
                        });
                    } else { console.log(error); }
                    this.setState({ saving: false });
                });
            });
        }
    }
    updateReport = report => {
        console.log(report);
        const { onAlert, onUpdateReport, advertiser } = this.props;
        this.setState({ saving: true }, () => {
            onUpdateReport(Object.assign({}, report, { acl: advertiser.acl })).then(result => {
                onAlert('success', `Successfully updated report: ${report.menuLabel}`);
                this.setState({ saving: false });
            }).catch(error => {
                if (error.graphQLErrors) {
                    error.graphQLErrors.map(({ message }, i) => {
                        if (message.match(/not authorized/gi)) {
                            onAlert('error', 'You are not authorised to edit reports, please see a System Admin');
                        }
                        else { onAlert('error', message); }
                    });
                }
                this.setState({ saving: false });
            });
        })
    }

    deleteReport = report => {
        const { onAlert, onDeleteReport } = this.props;
        this.setState({ saving: true }, () => {
            onDeleteReport(report).then(result => {
                onAlert('success', `Successfully delted report: ${report.menuLabel}`);
                this.setState({ saving: false });
            }).catch(error => {
                if (error.graphQLErrors) {
                    error.graphQLErrors.map(({ message }, i) => {
                        if (message.match(/not authorized/gi)) {
                            onAlert('error', 'You are not authorised to delete reports, please contact System Admin');
                        }
                        else { onAlert('error', message); }
                    });
                }
                this.setState({ saving: false });
            });
        });
    }

    render() {
        const { advertiser, loading, pageTabs, users, reportTypes } = this.props;
        const { activeTabIndex, saving } = this.state;
        return (
            <React.Fragment>
                <PageNavigationTabs pageTabs={pageTabs} activeTabIndex={activeTabIndex} onTabClick={this.tabClickHandler} />
                <Route path="/organisations/advertisers/:id/manage/settings" render={routeProps =>
                    <AdvertiserEdit {...routeProps} advertiser={advertiser} loading={loading || saving} saveHandler={this.saveAdvertiser} onActivate={event => this.setActiveTab(1)} />} />
                <Route path="/organisations/advertisers/:id/manage/reports" render={routeProps =>
                    <ReportList {...this.props} {...routeProps} reports={advertiser.reports}
                        reportTypes={reportTypes} loading={loading || saving} deleteHandler={this.deleteReport}
                        saveHandler={this.createReport} updateHandler={this.updateReport} fileUpdateHandler={this.updateReportFile} onActivate={event => this.setActiveTab(3)} />} />
                <Route path="/organisations/advertisers/:id/manage/acls" render={routeProps =>
                    <ACLList advertiser={advertiser} loading={loading || saving} users={users} onAdvertiserUpdated={this.saveAdvertiser} onActivate={event => this.setActiveTab(4)} />} />
                <Route path="/organisations/advertisers/:id/manage/brands" render={routeProps =>
                    <BrandList advertiser={advertiser} loading={loading || saving} users={users} onAdvertiserUpdated={this.saveAdvertiser} onActivate={event => this.setActiveTab(5)} />} />
            </React.Fragment>
        );
    }
}

export default
    compose(
        graphql(GetAdvertiserQuery, {
            options: ({ match: { params: { id } } }) => ({ variables: { id } }),
            props: ({ data: { getAdvertiser, listUsers, listReportTypes, loading } }) => ({
                advertiser: getAdvertiser,
                users: listUsers && listUsers.items,
                reportTypes: listReportTypes && listReportTypes.items,
                loading
            })
        }),
        graphql(UpdateAdvertiserMutation([
            'costModifier',
            'postClickLookback',
            'postViewLookback',
            'acl',
            'accessControlList{id userName}',
            'brands',
            'reports{id name version}'
        ]), {
                props: ({ mutate }) => ({ onUpdate: input => mutate({ variables: { input } }) })
            }),
        graphql(NewReportMutation, {
            props: ({ mutate }) => ({
                onAddReport: input => {
                    return mutate({
                        variables: { ...input },
                        optimisticResponse: () => ({ createReport: { ...input, __typename: 'Report' } }),
                    })
                }
            }),
            options: ({ match: { params: { id } } }) => ({
                refetchQueries: [{ query: GetAdvertiserQuery, variables: { id } }],
                update: (dataProxy, { data: { createReport } }) => {
                    const query = GetAdvertiserQuery;
                    const data = dataProxy.readQuery({ query, variables: { id } });
                    let advertiser = Object.assign({}, data.getAdvertiser, { reports: [...data.getAdvertiser.reports, createReport] });
                    dataProxy.writeQuery({ query, data: { getAdvertiser: advertiser } });
                }
            })
        }),
        graphql(UpdateReportFileMutation, {
            props: ({ mutate }) => ({
                onUpdateReportFile: input => {
                    return mutate({
                        variables: { ...input }
                    })
                }
            })
        }),
        graphql(UpdateReportMutation, {
            props: ({ mutate }) => ({
                onUpdateReport: input => {
                    return mutate({
                        variables: { input }
                    })
                }
            })
        }),
        graphql(DeleteReportMutation, {
            props: ({ mutate }) => ({
                onDeleteReport: input => {
                    return mutate({ variables: { id: input.id } });
                }
            })
        })
    )(AdvertiserEditContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Advertisers/Edit.js